import { can } from "../../auth/can.ts";
import React from "react";
import { useParams } from "react-router-dom";
import ChipStatus from "./ChipStatus.tsx";
import { getCurrencyFormat } from "../../utils/index.ts";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import EmptyImage from "../../assets/img/ic_content.svg";

const ApplicationListReinstatements = ({ applications, size = "lg" }) => {
  const { curp } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);

  const filteredApplications = applications?.candidate?.filter(application =>
    application.application
  );

  return (
    <div className="col-xl-8" id="bsSpyContent">
      <div id="Aplications" className="mb-4 pb-3">
        {size === "lg" && (
          <React.Fragment>
            <h4 className="d-flex align-items-center mb-2">
              Aplicaciones
            </h4>
            <p className="text-muted">
              Aquí puedes encontrar todas las postulaciones que se han realizado
              con la CURP {curp}.
            </p>
          </React.Fragment>
        )}
        <div className="row g-3">
          {filteredApplications?.map((application, index) => {
            const dateTimeString = `${application.application.applicationDate} ${application.application.applicationTime}`;
            const date = parseISO(dateTimeString);
            const formattedDateTime = format(
              date,
              "dd 'de' MMMM yyyy, HH:mm 'hrs'",
              { locale: es }
            );

            return (
              <div className="col-12" key={index}>
                <div className="card shadow-sm border h-100 rounded-3 overflow-hidden">
                  <div className="card-body position-relative pt-3 pb-3 ps-4 pe-4">
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                      <h6 className="card-title mb-0 fw-bold text-dark fs-6">
                        {application.application.vacancy.position.name}
                      </h6>
                      <ChipStatus
                        status={
                          application.application.applicationStatus
                            .name as any
                        }
                      />
                    </div>
                    <p className="card-text text-muted small mb-1">
                      <i className="fa-solid fa-building me-1" />
                      en {application.application.vacancy.branch.name}
                    </p>
                    {can("partners.view_salary", user) && (
                      <p className="card-text text-muted small mb-1">
                        <i className="fa-solid fa-coins me-1" />
                        Expectativa salarial:{" "}
                        {getCurrencyFormat(
                          application.application.monthlySalary
                        )}
                      </p>
                    )}
                    <p className="card-text text-muted small mb-0">
                      <i className="fa-solid fa-calendar-check me-1" />
                      Cita: {formattedDateTime}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredApplications?.length === 0 && (
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-body py-5 text-center">
              <img src={EmptyImage} alt="" className="img-fluid mb-3" style={{ maxWidth: "200px" }} />
              <h5 className="text-secondary mb-0">
                No existen registros de reincorporación aún
              </h5>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationListReinstatements;
